import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Typography, TextField, Button, Modal } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import {
  uploadSourceFile,
  dataSourceList,
  publicFileLink,
  downloadTemplateFile,
  insertExcel,
  deleteSourceFile,
  deleteSourceData,
  getFileOwner,
} from "../Service";
import moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import BtnUpdFileIcon from "../../img/UploadFileWhite.png";
import "../../styles/customSwalStyles.css";
import Unauthorized from "../Unauthorized";
import { addLog } from "../../utils/addLog";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useTranslation } from "react-i18next";
import { BsFillXCircleFill } from "react-icons/bs";
import { TableSortLabel } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { signOut } from "../../utils/signOut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Resource() {
  const [t, i18n] = useTranslation("global");

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );
  const [userRole, setUserRole] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserRole"))
  );
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [progress, setProgress] = React.useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [data, setData] = useState({ total: 0 });
  const [msgUpload, setMsgUpload] = useState("");
  const [msgInsertExcel, setMsgInsertExcel] = useState("");

  const [id, setId] = useState(null);
  const [fileId, setFileId] = useState(null);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("GroupID");
  const sortedData = [...dataSource].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };

  const fileRef = useRef(null);
  const location = useLocation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filename, setFilename] = useState("");
  const [form, setForm] = useState("");
  const [status, setStatus] = useState("");
  const [statusCode, setStatusCode] = useState("");
  const [formCode, setFormCode] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setFile(null);
    setFileName(null);
    setOpen(true);
    setloadingbutton(false);
  };
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };

  const handleClearSearch = () => {
    setFilename("");
  };

  const [openModal, setOpenModal] = useState(false);
  const [loadingbutton, setloadingbutton] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    handleRemove();
    setSumErrorMsg("");
  };

  const [openModalMultidelete, setOpenModalMultidelete] = useState(false);
  const [openModaldelete, setOpenModaldelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);
  const handleOpenModaldelete = () => {
    setloadingbuttondelete(false);
    setOpenModaldelete(true);
  };
  const handleCloseModaldelete = () => setOpenModaldelete(false);

  const handleClickModaldelete = () => {
    setloadingbuttondelete(true);
    deleteFile();
  };

  const handleOpenModalMultidelete = () => {
    setOpenModalMultidelete(true);
  };

  const handleClickModal = () => {
    setloadingbutton(true);
    uploadExcelFile();
    addLog("Resource", "Input data", null);
  };

  const [fileInfo, setFileInfo] = useState(null);

  async function deleteFile() {
    // Check file owner
    if (userData.department !== "IT") {
      const qString = `?filename=${fileInfo.name}&department=${userData.department}`;
      let isError = false;
      await getFileOwner(qString).then((res) => {
        if (res && res.status === 200 && res.data.success === true) {
          if (!res.data.is_owner) {
            isError = true;
            handleCloseModaldelete();
            Swal.fire({
              position: "center",
              icon: "warning",
              // title: "Permission denied",
              // text: "You are not allow to delete file of other department.",
              title: t("resource.err.delete.title"),
              text: t("resource.err.delete.msg1"),
              showConfirmButton: false,
            });
          }
        } else {
          isError = true;
          handleCloseModaldelete();
          Swal.fire({
            icon: "error",
            title: res.data.message,
            text: "",
          });
          console.log(`error getFileOwner:`, res.data.err);
        }
      });
      if (isError) {
        handleCloseModaldelete();
        return;
      }
    }

    // |1| Delete data in DB
    let data = {
      datatime: moment(fileInfo.updated).format("YYYY-MM-DD HH:mm:ss"),
    };

    let updSuccess = false;
    await deleteSourceData(data).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        updSuccess = true;
      } else if (res.status === 401) {
        handleCloseModaldelete();
        setloadingbuttondelete(false);
        signOut();
      } else {
        handleCloseModaldelete();
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: "",
        });
        console.log(`error deleteSourceData:`, res.data.err);
        setloadingbuttondelete(false);
      }
    });

    // |2| Delete file from GCS
    if (updSuccess) {
      let dataForm = {
        filename: fileInfo.name,
      };

      await deleteSourceFile(dataForm).then((res) => {
        if (res && res.status === 200 && res.data.success === true) {
          handleCloseModaldelete();
          Swal.fire({
            position: "center",
            icon: "success",
            // title: "Delete file successfully",
            title: t("resource.success.delete"),
            showConfirmButton: false,
            timer: 5000,
          });
          setPage(0);
          getData(0, rowsPerPage);
        } else {
          handleCloseModaldelete();
          Swal.fire({
            icon: "error",
            title: res.data.message,
            text: "",
          });
          console.log(`error deleteSourceFile:`, res.data.err);
        }
        setloadingbuttondelete(false);
      });
    }
  }

  const headCells = [
    {
      id: "SourceFile",
      numeric: false,
      disablePadding: true,
      sortKey: "name",
      label: t("resource.table.header.source"),
    },
    {
      id: "UploadBy",
      numeric: false,
      disablePadding: true,
      sortKey: "upload_by",
      label: t("resource.table.header.by"),
    },
    {
      id: "ImportTime",
      numeric: false,
      disablePadding: false,
      sortKey: "updated",
      label: t("resource.table.header.time"),
    },
    {
      id: "Action",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("user.table.header.action"),
    },
  ];

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  React.useEffect(() => {
    getData(0, rowsPerPage);
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const getData = async (nowPage, nowRowsPerPage) => {
    // Verify role admin up
    if (!userRole.role.includes("admin")) {
      return;
    }

    setLoading(true);

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    if (filename) qString = qString + "&filename=" + filename;

    await dataSourceList(qString).then((res) => {
      if (res && res?.status === 200) {
        // For paginate
        setDataSource(res.data.data);
        setData(res.data);
      } else if (res?.status === 401) {
        signOut();
      } else if (res === undefined) {
        Swal.fire({
          icon: "error",
          title: "Database connection failed",
          text: "Please contact administrator",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: res?.data.message,
          text: res?.data.error,
        });
      }
      setLoading(false);
    });
  };

  function getFileUrl(file) {
    const dataForm = {
      filename: file,
    };

    publicFileLink(dataForm).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        const newWindow = window.open(
          res.data.link,
          "_blank",
          "noopener,noreferrer"
        );
        if (newWindow) newWindow.opener = null;
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: res.data.error,
        });
      }
    });
  }

  const acceptableFileName = ["zip", "7z"];

  const checkFileName = (name) => {
    return name.toLowerCase().includes("xlsx");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  //////////////// Import pdf files ////////////////

  const handleFile = async (e) => {
    const myFile = e.target.files[0];

    if (!myFile) return;

    if (!checkFileName(myFile.name)) {
      Swal.fire({
        icon: "warning",
        text: t("resource.err.filetype"),
        position: "center",
        customClass: {
          container: "my-swal-container", // Apply custom class for container
        },
      });
      return;
    }

    setFile(myFile);
    setFileName(myFile.name);
    setErrorMsg("");
    setSumErrorMsg("");
  };

  const handleButtonClick = () => {
    fileRef.current.click();
  };

  const uploadExcelFile = async () => {
    var formData = new FormData();

    if (fileRef) {
      formData.append("file", fileRef.current.files[0]);
      formData.append("fname", fileName);
      formData.append("user_id", userData.userID);
      formData.append("uname", userData.name);
    }

    let updSuccess = false;
    let fileCreated = {};
    await uploadSourceFile(formData).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        updSuccess = true;
        fileCreated = res.data;
      } else if (res.status === 401) {
        handleRemove();
        handleClose(); // close upload modal
        setloadingbutton(false);
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload file failed!",
          customClass: {
            container: "my-swal-container", // Apply custom class for container
          },
        });
        console.log(`error uploadSourceFile:`, res);
        handleRemove();
        handleClose(); // close upload modal
        setloadingbutton(false);
      }
    });

    if (updSuccess) {
      // Call InsertExcel API for insert data to BigQuery ---------
      const dataForm = {
        file_name: fileName,
        created: moment(fileCreated.created).format("YYYY-MM-DD HH:mm:ss"),
        updated: moment(fileCreated.updated).format("YYYY-MM-DD HH:mm:ss"),
      };

      await insertExcel(dataForm).then((res) => {
        if (res && res.status === 200 && res.data.success === true) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: t("resource.success.upload"),
            showConfirmButton: false,
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
        } else {
          // Error message
          Swal.fire({
            icon: "error",
            title: res.data.message,
            text: res.data.err_data,
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
          console.log(`error insertExcel:`, res);
        }
        handleRemove();
        handleClose(); // close upload modal

        setloadingbutton(false);
      });
      // End insert -----------------------------------------------

      setPage(0);
      getData(0, rowsPerPage);
    }
  };

  const handleRemove = (jsonData) => {
    setFile(null);
    setFileName(null);

    fileRef.current.value = "";
  };

  const handleClickDownload = async () => {
    await downloadTemplateFile().then((res) => {
      if (res && res.status === 200) {
        const filename = "InputTemplate.xlsx";

        var blob = new Blob([res.data]);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var newBlobIE = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          return navigator.msSaveOrOpenBlob(newBlobIE, filename);
        }
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops...",
          text: "Template file not found in GCS!",
        });
      }
    });
  };

  const handleClickSearch = async () => {
    setPage(0);
    await getData(0, rowsPerPage);
    addLog("Resource", "Search", null);
  };

  return (
    <Box
      style={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={openSnack}
        autoHideDuration={10000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnack}
          severity="warning"
          sx={{ width: "100%", fontSize: "16px", padding: 2 }}
        >
          {sumErrorMsg}
        </Alert>
      </Snackbar>
      {/*  ////////////////////////// Main Topic Pages ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            style={{
              fontWeight: "400",
              color: "#5C5C5C",
              fontSize: "1.8rem",
              whiteSpace: "nowrap",
            }}
          >
            {t("resource.header")}
          </Typography>
        </Box>
      </Box>
      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {userRole.role.includes("admin") ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  mr: 2,
                  mt: { xs: "10px" },
                  width: { lg: 500 },
                }}
              >
                <TextField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderColor: "white",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                  }}
                  placeholder={t("resource.txtbox.search")}
                  size="middle"
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      backgroundColor: "#F0F0F0",
                      paddingLeft: "15px",
                      fontSize: "medium",
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <IconButton
                        sx={{
                          visibility: filename ? "visible" : "hidden",
                        }}
                        onClick={handleClearSearch}
                      >
                        <ClearIcon />
                      </IconButton>
                    ),
                  }}
                  fullWidth
                  value={filename}
                  onChange={(e) => {
                    setFilename(e.target.value);
                  }}
                />
              </Box>

              <Box sx={{ mr: 2, mt: { xs: "10px" } }}>
                <LoadingButton
                  onClick={handleClickSearch}
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: "#5C5C5C",
                    color: "#FFFFFF",
                    borderRadius: "10px",
                    height: "45px",
                    textTransform: "none",
                    width: "100px",
                  }}
                >
                  {t("common.button.search")}
                </LoadingButton>
              </Box>
            </>
          ) : (
            ""
          )}

          {!userRole.role.includes("admin") ? (
            <Box sx={{ mt: { xs: "10px" } }}>
              <Typography variant="body1" sx={{ ml: 1, color: "#5C5C5C" }}>
                The input template file is available only ➡️ &nbsp;&nbsp;
              </Typography>
            </Box>
          ) : (
            ""
          )}
          {/*  ////////////////////////// Download Button ////////////////////////// */}
          <Box sx={{ mt: { xs: "10px" } }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<FileUploadOutlinedIcon />}
              style={{
                backgroundColor: "#7399D1",
                color: "#FFFFFF",
                borderRadius: "10px",
                height: "45px",
                textTransform: "none",
              }}
              onClick={handleClickDownload}
            >
              {t("resource.button.download")}
            </Button>
          </Box>
        </Box>
        {/*  ////////////////////////// Import Button ////////////////////////// */}
        {userRole.role.includes("admin") ? (
          <Box>
            <Box sx={{ mt: { xs: "10px" } }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<img src={BtnUpdFileIcon} style={styles.BtnIcon} />}
                style={{
                  backgroundColor: "#7399D1",
                  color: "#FFFFFF",
                  borderRadius: "10px",
                  height: "45px",
                  textTransform: "none",
                }}
                onClick={handleOpen}
              >
                {t("resource.button.upload")}
              </Button>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Box>

      {sortedData.length > 0 &&
      sortedData.filter((item) => item.isChecked === true).length > 0 ? (
        <>
          <Box
            sx={{
              display: "flex",
              paddingBottom: "5px",
            }}
          >
            <Box sx={{ display: "flex", mr: 2 }}>
              <LoadingButton
                onClick={handleOpenModalMultidelete}
                loadingIndicator="Loading…"
                variant="contained"
                size="medium"
                color="secondary"
              >
                ลบรายการที่เลือก
              </LoadingButton>
            </Box>
          </Box>
        </>
      ) : (
        ""
      )}
      {userRole.role.includes("admin") ? (
        <>
          {/*  ////////////////////////// Data Table ////////////////////////// */}
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
              <TableHead>
                <TableRow>
                  {headCells.map((headCell, index) => (
                    <TableCell
                      key={index}
                      align={headCell.numeric ? "right" : "left"}
                      padding={headCell.disablePadding ? "none" : "normal"}
                      sx={{
                        backgroundColor: "#c4e6ff",
                        padding: "10px",
                        fontWeight: "bold",
                        color: "#1D589D",
                      }}
                      sortDirection={
                        orderBy === headCell.sortKey ? order : false
                      }
                    >
                      {headCell.sortKey !== null ? (
                        <TableSortLabel
                          active={orderBy === headCell.sortKey}
                          direction={
                            orderBy === headCell.sortKey ? order : "asc"
                          }
                          onClick={() => handleRequestSort(headCell.sortKey)}
                        >
                          {headCell.label}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <CircularProgress color="inherit" />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : sortedData.length > 0 ? (
                  sortedData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <Button
                          variant="text"
                          style={{
                            textTransform: "none",
                            fontSize: "16px",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            color: "black",
                          }}
                          size="small"
                          onClick={() => {
                            getFileUrl(row.name);
                          }}
                        >
                          {row.name}
                        </Button>
                      </TableCell>
                      <TableCell style={{ maxWidth: 200 }} align="left">
                        <Typography>{row.upload_by}</Typography>
                      </TableCell>
                      <TableCell
                        style={{ minWidth: 80, maxWidth: 180 }}
                        align="left"
                      >
                        <Typography>
                          {row.updated
                            ? moment(row.updated).format("YYYY-MM-DD HH:mm:ss")
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ maxWidth: 60 }} align="left">
                        <IconButton
                          size="medium"
                          onClick={() => {
                            setFileInfo(row);
                            handleOpenModaldelete();
                          }}
                        >
                          <BsFillXCircleFill style={{ color: "#f44336" }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Box
                        style={{ display: "flex", justifyContent: "center" }}
                      ></Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    colSpan={4}
                    count={data.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </>
      ) : (
        <Unauthorized />
      )}

      {/*//////////////// Modal popup for Upload files ////////////////*/}
      <Modal open={open}>
        <Box sx={style}>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography variant="h5">
              {t("resource.popup.upload.header")}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                {fileName && (
                  <Typography
                    style={{
                      fontSize: "14px",
                      color: "#357a38",
                      fontWeight: 400,
                    }}
                  >
                    {t("resource.popup.upload.txt5")}
                  </Typography>
                )}
                {!fileName && (
                  <Typography style={{ fontSize: "14px", color: "#9E9E9E" }}>
                    {t("resource.popup.upload.txt1")}
                  </Typography>
                )}
              </Box>
              <Box>
                <input
                  type="file"
                  accept=".xlsx"
                  ref={fileRef}
                  onChange={(e) => handleFile(e)}
                  style={{ display: "none" }} // Hide the default input
                />
                <button onClick={handleButtonClick}>
                  {t("resource.popup.upload.txt2")}
                </button>
              </Box>
            </Box>
          </Box>

          {fileName && (
            <Box
              sx={{
                mt: 3,
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Typography fontSize={14}>
                <span style={{ color: "#1565c0", fontWeight: 500 }}>
                  {t("resource.popup.upload.txt4")}{" "}
                </span>
                {fileName ? (
                  <>
                    {fileName}
                    <ClearIcon
                      onClick={() => {
                        handleRemove();
                      }}
                    />
                  </>
                ) : (
                  <span style={{ color: "#c62828" }}>"กรุณาระบุ ชื่อไฟล์"</span>
                )}
              </Typography>
            </Box>
          )}
          <br />

          <Box
            sx={{
              mt: 5,
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography color="error" variant="h6" fontWeight={400}>
                {errorMsg}
              </Typography>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleClickModal}
                loading={loadingbutton}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                size="small"
                disabled={fileName ? false : true}
              >
                <span>{t("resource.button.upload")}</span>
              </LoadingButton>

              <Button
                style={{ marginLeft: 12 }}
                variant="outlined"
                size="middle"
                color="inherit"
                onClick={() => {
                  handleClose();
                  handleRemove();
                }}
              >
                <Typography fontSize={14}>
                  {t("common.button.cancel")}
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* /////////// Modal confirm Delete form /////////// */}
      <Modal open={openModaldelete}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("resource.popup.delete.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModaldelete}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("resource.popup.delete.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="error"
              onClick={handleClickModaldelete}
              loading={loadingbuttondelete}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              variant="contained"
              size="medium"
            >
              {t("common.button.del")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseModaldelete}
            >
              {t("common.button.cancel")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
